import { Badge, Button, Card, Carousel, Col, Row } from 'react-bootstrap';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  HatenaIcon,
  HatenaShareButton,
  InstapaperIcon,
  InstapaperShareButton,
  LineIcon,
  LineShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  LivejournalIcon,
  LivejournalShareButton,
  MailruIcon,
  MailruShareButton,
  OKIcon,
  OKShareButton,
  PinterestIcon,
  PinterestShareButton,
  PocketIcon,
  PocketShareButton,
  RedditIcon,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
  TumblrIcon,
  TumblrShareButton,
  TwitterIcon,
  TwitterShareButton,
  VKIcon,
  VKShareButton,
  ViberIcon,
  ViberShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  WorkplaceIcon,
  WorkplaceShareButton,
} from 'react-share';
import { FixedSizeGrid as Grid, FixedSizeList as List } from 'react-window';
import { Link, navigate } from 'gatsby';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Router, useLocation } from '@reach/router';

import AniLink from 'gatsby-plugin-transition-link/AniLink';
import { ImCircleLeft } from '@react-icons/all-files/im/ImCircleLeft';
import { ImCircleRight } from '@react-icons/all-files/im/ImCircleRight';
import Img from 'gatsby-image';
import ReactMarkdown from 'react-markdown';
import { ReactWindowScroller } from 'react-window-scroller';
import SEO from '../components/seo';
import Skeleton from '../components/Skeleton';
import TrailTitle from '../components/TrailTitle';
import createTrigger from 'react-use-trigger';
import { css } from '@emotion/react';
import qs from 'qs';
import styled from '@emotion/styled';
import useFetch from 'react-fetch-hook';
import { useMediaQuery } from '@react-hook/media-query';
import useTrigger from 'react-use-trigger/useTrigger';


const BgRow = styled(Row)`
  min-height         : 75vh;
  background-image   : url('${(props) => props.background}');
  background-repeat  : no-repeat;
  background-position: top right;
`;

const fit = css`
  width: fit-content;
`;

const stickBottom = css`
  text-align: start;
  position  : sticky;
  bottom    : 4px;
  margin    : 0 4px;
  z-index   : 1;
`;

const stickTop = css`
  text-align: start;
  position  : fixed;
  top       : 4px;
  right     : 0;
  margin    : 0 4px;
  z-index   : 1;
`;

const NewsCard = ({ data, type }) => (
  <Card>
    <Card.Img
      variant = 'top'
      css     = {{
        objectFit: 'cover',
        height   : 300,
      }}
      src={
        data.foto_artikel
          ? `https://iik.ac.id${data.foto_artikel}`
          :  'http://placehold.it/300x200?text=RSGM IIK BW'
      }
    />
    <Card.Body>
      <Card.Title>{data.artcle_full_title}</Card.Title>
      <Row className='mb-3'>
        <Col xs={'6'}>
          <Badge variant='secondary'>{data.artcle_tanggal}</Badge>
        </Col>
      </Row>
      <AniLink cover bg='#c2912e' to={`/news/${data.artcle_id}?type=${type}`}>
        Baca selengkapnya
      </AniLink>
    </Card.Body>
  </Card>
);

const useResponsiveBreakpoints = () => {
  const xs = useMediaQuery('only screen and (max-width: 600px)');
  const sm = useMediaQuery(
    'only screen and (min-width: 600px) and (max-width: 960px)'
  );
  const md = useMediaQuery(
    'only screen and (min-width: 600px) and (max-width: 1280px)'
  );
  const lg = useMediaQuery(
    'only screen and (min-width: 1280px) and (max-width: 1920px)'
  );
  const xl = useMediaQuery('only screen and (min-width: 1920px)');
  return { xs, sm, md, lg, xl };
};
const loadNews = createTrigger();

const Newses = ({ location }) => {
  const query = location.search ? qs.parse(location.search.substring(1)) : {};

  const { xs, sm, md, lg, xl }    = useResponsiveBreakpoints();
  const [page, setPage]           = useState(1);
  const [lastIndex, setLastIndex] = useState(0);
  const [noMore, setNoMore]       = useState(false);

  const [news, setNews] = useState([]);
  const refetchNews     = useTrigger(loadNews);
  const containerRef = useRef(null);

  const { isLoading, error, data } = useFetch(
    `https://iik.ac.id/web.php?${qs.stringify({
      r    : 'iik-api',
      sp   : 'iik-news-list',
      limit: 6,
      page,
      inp_filter: query.search || '',
    })}`,
    {
      depends: [refetchNews],
    }
  );

  useEffect(() => {
    if (data) {
      const old = news.slice(0, news.length - 1);
      if (data.length > 0) {
        setNews([
          ...old,
          // ...data.filter((d) => !old.some((n) => n.artcle_id === d.artcle_id)),
          ...data,
        ]);
      } else {
        setNews([...old]);
        setNoMore(true);
      }
      // setNews(data);
    }
  }, [data]);

  const loadMoreItems = ({
    visibleStartIndex,
    visibleStopIndex,
    visibleRowStartIndex,
    visibleRowStopIndex,
  }) => {
    if (
      visibleStopIndex - visibleStartIndex < 1 ||
      visibleRowStopIndex - visibleRowStartIndex < 1
    ) {
      if (visibleStartIndex > lastIndex || visibleRowStartIndex > lastIndex) {
        if (!noMore) {
          setLastIndex(visibleStartIndex || visibleRowStartIndex);
          news[news.length - 1] !== null && setNews([...news, null]);
          setPage(page + 1);
        }
      }
    }
  };

  // const responsiveWidth = useMemo(() => {
  //   // if (md) {
  //   //   return 355;
  //   // } else if (lg) {
  //   //   return 455;
  //   // } else if (xl) {
  //   //   return 535;
  //   // } else {
  //   //   return typeof window !== 'undefined' ? window.innerWidth: 0;
  //   // }
  //   console.log(
  //     xs,
  //     sm,
  //     md,
  //     lg,
  //     xl,
  //     containerRef.current?.getBoundingClientRect()
  //   );
  //   return containerRef.current
  //     ? containerRef.current.getBoundingClientRect()['width'] / 2
  //     :  300;
  // }, [xs, sm, md, lg, xl, containerRef.current]);
  const responsiveWidth = containerRef.current
    ? containerRef.current.getBoundingClientRect()['width'] / 2
    :  300;

  if (error) {
    console.error(error);
  }

  return (
    <>
      <Col
        xs = {{ span: '12', order: 'last' }}
        md = {{ span: '9', order: 'first' }}>
        <h5 className='bg-primary text-white p-2' css={fit} id='news'>
          News
        </h5>
        <div
          className = 'pt-3 pb-3'
          css       = {{ backgroundColor: '#F0F0F0' }}
          ref       = {containerRef}>
          {news.length > 0 &&
            (xs || sm ? (
              <ReactWindowScroller>
                {({ ref, outerRef, style, onScroll }) => (
                  <List
                    ref             = {ref}
                    outerRef        = {outerRef}
                    style           = {style}
                    height          = {window.innerHeight}
                    itemCount       = {news.length}
                    itemSize        = {500}
                    onScroll        = {onScroll}
                    onItemsRendered = {loadMoreItems}
                    overscanCount   = {4}>
                    {({ index: idx, style }) => {
                      const evt = news[idx];

                      return evt === null ? (
                        <Skeleton
                          height    = '500px'
                          width     = '100%'
                          className = 'mb-2'
                          style     = {style}
                        />
                      ) : (
                        <div className={`mb-2`} style={style}>
                          <NewsCard data={evt} type='news' />
                        </div>
                      );
                    }}
                  </List>
                )}
              </ReactWindowScroller>
            ) : (
              <ReactWindowScroller isGrid>
                {({ ref, outerRef, style, onScroll }) => (
                  <Grid
                    ref         = {ref}
                    outerRef    = {outerRef}
                    style       = {style}
                    height      = {window.innerHeight}
                    width       = {window.innerWidth}
                    columnCount = {2}
                    columnWidth     = {responsiveWidth}
                    rowCount        = {Math.ceil(news.length / 2)}
                    rowHeight       = {500}
                    onScroll        = {onScroll}
                    onItemsRendered = {loadMoreItems}
                    overscanCount   = {3}>
                    {({ columnIndex, rowIndex, style }) => {
                      const evt =
                        news[columnIndex + rowIndex + rowIndex] || null;

                      return evt === null ? (
                        <Skeleton
                          height    = 'auto'
                          width     = '500px'
                          className = 'pl-1 pr-1'
                          style     = {style}
                        />
                      ) : (
                        <div className={`pl-1 pr-1`} style={style}>
                          <NewsCard data={evt} type='news' />
                        </div>
                      );
                    }}
                  </Grid>
                )}
              </ReactWindowScroller>
            ))}
          {!isLoading && news.length === 0 && (
            <div className='d-flex justify-center align-items-center align-content-center p-5 bg-secondary'>
              Tidak ada berita terbaru
            </div>
          )}
        </div>
      </Col>
    </>
  );
};

const loadEvents = createTrigger();

const Events = ({ location }) => {
  const query = location.search ? qs.parse(location.search.substring(1)) : {};

  const { xs, sm, md, lg, xl }    = useResponsiveBreakpoints();
  const [page, setPage]           = useState(1);
  const [lastIndex, setLastIndex] = useState(0);
  const [noMore, setNoMore]       = useState(false);

  const [events, setEvents] = useState([]);
  const refetchEvents       = useTrigger(loadEvents);

  const { isLoading, error, data } = useFetch(
    `https://iik.ac.id/web.php?${qs.stringify({
      r    : 'iik-api',
      sp   : 'iik-event-list',
      limit: 2,
      page,
      inp_filter: query.search || '',
    })}`,
    {
      depends: [refetchEvents],
    }
  );

  useEffect(() => {
    if (data) {
      const old = events.slice(0, events.length - 1);
      if (data.length > 0) {
        setEvents([
          ...old,
          ...data.filter((d) => !old.some((n) => n.artcle_id === d.artcle_id)),
        ]);
      } else {
        setEvents([...old]);
        setNoMore(true);
      }
      // setEvents(data);
    }
  }, [data]);

  const loadMoreItems = ({
    visibleStartIndex,
    visibleStopIndex,
    visibleColumnStartIndex,
    visibleColumnStopIndex,
  }) => {
    if (
      visibleStopIndex - visibleStartIndex < 1 ||
      visibleColumnStopIndex - visibleColumnStartIndex < 1
    ) {
      if (
        visibleStartIndex > lastIndex ||
        visibleColumnStartIndex > lastIndex
      ) {
        if (!noMore) {
          setLastIndex(visibleStartIndex || visibleColumnStartIndex);
          events[events.length - 1] !== null && setEvents([...events, null]);
          setPage(page + 1);
        }
      }
    }
  };

  if (error) {
    console.error(error);
  }

  return (
    <>
      <Col
        xs = {{ span: '12', order: 'first' }}
        md = {{ span: '3', order: 'last' }}>
        <h5 className='bg-primary text-white p-2' css={fit} id='upcoming'>
          Upcoming Event
        </h5>
        <div className='pt-2 pb-2'>
          {events.length > 0 &&
            (!xs && !sm ? (
              <ReactWindowScroller>
                {({ ref, outerRef, style, onScroll }) => (
                  <List
                    ref             = {ref}
                    outerRef        = {outerRef}
                    style           = {style}
                    height          = {window.innerHeight}
                    itemCount       = {events.length}
                    itemSize        = {500}
                    onScroll        = {onScroll}
                    onItemsRendered = {loadMoreItems}
                    overscanCount   = {3}>
                    {({ index: idx, style }) => {
                      const evt = events[idx];

                      return evt === null ? (
                        <Skeleton
                          height    = '500px'
                          width     = '100%'
                          className = 'mb-2'
                          style     = {style}
                        />
                      ) : (
                        <div className={`mb-2`} style={style}>
                          <NewsCard data={evt} type='evt' />
                        </div>
                      );
                    }}
                  </List>
                )}
              </ReactWindowScroller>
            ) : (
              <Grid
                className       = 'd-inline-block w-100 h-100'
                height          = {window.innerHeight}
                width           = {window.innerWidth}
                columnCount     = {events.length}
                columnWidth     = {window.innerWidth - 16}
                rowCount        = {1}
                rowHeight       = {500}
                onItemsRendered = {loadMoreItems}
                overscanCount   = {3}>
                {({ columnIndex: idx, style }) => {
                  const evt = events[idx];

                  return evt === null ? (
                    <Skeleton
                      height    = 'auto'
                      width     = '100%'
                      className = 'pl-1 pr-1'
                      style     = {style}
                    />
                  ) : (
                    <div className={`pl-1 pr-1`} style={style}>
                      <NewsCard data={evt} type='evt' />
                    </div>
                  );
                }}
              </Grid>
            ))}
          {!isLoading && events.length === 0 && (
            <div className='d-flex justify-center align-items-center align-content-center p-5 bg-secondary'>
              Tidak ada acara yang akan berlangsung
            </div>
          )}
        </div>
      </Col>
    </>
  );
};

const NewsList = ({ background, location }) => {
  return (
    <BgRow className='pt-5' background={background}>
      <Col
        xs        = {'12'}
        md        = {'5'}
        className = 'd-flex flex-column align-items-center align-content-center'>
        <TrailTitle open className='pb-2 mb-5'>
          <div>News</div>
          <div>&amp; Upcoming Event</div>
        </TrailTitle>
      </Col>
      <Col
        xs = {'12'}
        md = {{ span: '10', offset: 1 }}
        xl = {{ span: '8', offset: 2 }}>
        <h2 align='center'>What's on RSGM IIK BW</h2>
        <h4 align='center' className='mb-3'>
          Termukan berita terupdate dan event yang akan datang seputar RSGM IIK
          BW dengan memilih kategori berita.
        </h4>
        <Row>
          <Newses location={location} />
          <Events location={location} />
        </Row>
      </Col>
    </BgRow>
  );
};

const sharebtns = css`
  & button {
    margin: 4px;
  }
`;

const carousel = css`
  & .carousel-indicators li {
    background-color: var(--primary);
  }
  & .carousel-control-next,
  .carousel-control-prev {
    color    : var(--primary);
    font-size: 1.2rem;
  }
`;

const News = ({ background, location, slug }) => {
  const query                      = location.search ? qs.parse(location.search.substring(1)) : {};
  const loc                        = useLocation();
  const { isLoading, error, data } = useFetch(
    `https://iik.ac.id/web.php?${qs.stringify({
      r  : 'iik-api',
      sp : `${query.type}-details`,
      sqn: slug,
    })}`
  );

  if (error) {
    console.error(error);
  }

  const goBack = (event) => {
    event.preventDefault();
    navigate(loc.key === 'initial' ? '/news' : -1);
  };

  return (
    <BgRow className='pt-5 align-content-start' background={background}>
      <SEO
        title = {isLoading ? 'Berita' : error ? 'Error' : data.artcle_full_title}
      />
      <Col
        xs        = {'12'}
        sm        = {{ span: '8', offset: 2 }}
        className = 'd-flex flex-column align-items-center align-content-center mb-5'>
        {isLoading ? (
          <Skeleton height='3rem' />
        ) : (
          <>
            <h1 className='pb-2 mb-2'>
              {error ? 'Error' : data.artcle_full_title}
            </h1>
            <Row className='pl-3 pr-3 mb-3' css={sharebtns}>
              <EmailShareButton url={loc.href} subject={data.artcle_full_title}>
                <EmailIcon round size={32} />
              </EmailShareButton>
              <FacebookShareButton
                url   = {loc.href}
                quote = {data.artcle_full_title}>
                <FacebookIcon round size={32} />
              </FacebookShareButton>
              <HatenaShareButton url={loc.href} title={data.artcle_full_title}>
                <HatenaIcon round size={32} />
              </HatenaShareButton>
              <InstapaperShareButton
                url   = {loc.href}
                title = {data.artcle_full_title}>
                <InstapaperIcon round size={32} />
              </InstapaperShareButton>
              <LineShareButton url={loc.href} title={data.artcle_full_title}>
                <LineIcon round size={32} />
              </LineShareButton>
              <LinkedinShareButton
                url   = {loc.href}
                title = {data.artcle_full_title}>
                <LinkedinIcon round size={32} />
              </LinkedinShareButton>
              <LivejournalShareButton
                url   = {loc.href}
                title = {data.artcle_full_title}>
                <LivejournalIcon round size={32} />
              </LivejournalShareButton>
              <MailruShareButton url={loc.href} title={data.artcle_full_title}>
                <MailruIcon round size={32} />
              </MailruShareButton>
              <OKShareButton url={loc.href} title={data.artcle_full_title}>
                <OKIcon round size={32} />
              </OKShareButton>
              <PinterestShareButton
                url         = {loc.href}
                description = {data.artcle_full_title}>
                <PinterestIcon round size={32} />
              </PinterestShareButton>
              <PocketShareButton url={loc.href} title={data.artcle_full_title}>
                <PocketIcon round size={32} />
              </PocketShareButton>
              <RedditShareButton url={loc.href} title={data.artcle_full_title}>
                <RedditIcon round size={32} />
              </RedditShareButton>
              <TelegramShareButton
                url   = {loc.href}
                title = {data.artcle_full_title}>
                <TelegramIcon round size={32} />
              </TelegramShareButton>
              <TumblrShareButton url={loc.href} title={data.artcle_full_title}>
                <TumblrIcon round size={32} />
              </TumblrShareButton>
              <TwitterShareButton url={loc.href} title={data.artcle_full_title}>
                <TwitterIcon round size={32} />
              </TwitterShareButton>
              <ViberShareButton url={loc.href} title={data.artcle_full_title}>
                <ViberIcon round size={32} />
              </ViberShareButton>
              <VKShareButton url={loc.href} title={data.artcle_full_title}>
                <VKIcon round size={32} />
              </VKShareButton>
              <WhatsappShareButton
                url   = {loc.href}
                title = {data.artcle_full_title}>
                <WhatsappIcon round size={32} />
              </WhatsappShareButton>
              <WorkplaceShareButton
                url   = {loc.href}
                quote = {data.artcle_full_title}>
                <WorkplaceIcon round size={32} />
              </WorkplaceShareButton>
            </Row>
          </>
        )}
      </Col>
      <Col
        xs        = {'12'}
        sm        = {{ span: '8', offset: 2 }}
        className = 'd-flex flex-column align-items-center align-content-start'>
        {isLoading && (
          <>
            <Skeleton
              height    = '1rem'
              width     = '100%'
              className = 'm-2 align-self-start'
            />
            <Skeleton
              height    = '1rem'
              width     = '95%'
              className = 'm-2 align-self-start'
            />
            <Skeleton
              height    = '1rem'
              width     = '90%'
              className = 'm-2 align-self-start'
            />
            <Skeleton
              height    = '1rem'
              width     = '95%'
              className = 'm-2 align-self-start'
            />
            <Skeleton
              height    = '1rem'
              width     = '80%'
              className = 'm-2 align-self-start'
            />
          </>
        )}
        {error && <div>Terjadi kesalahan, coba muat ulang halaman.</div>}
        {!isLoading && !error && (
          <>
            {(data.foto_artikel || []).length > 0 && (
              <Carousel
                fade
                className = 'w-100'
                css       = {carousel}
                nextIcon  = {<ImCircleRight />}
                prevIcon  = {<ImCircleLeft />}>
                {data.foto_artikel.map((i, idx) => (
                  <Carousel.Item key={idx}>
                    <div css={{ paddingBottom: 128 }}>
                    <img
                      className = 'd-block m-auto'
                      src       = {`https://iik.ac.id${i.file}`}
                    />
                    </div>
                    <Carousel.Caption
                      css={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                      <p>{i.caption}</p>
                    </Carousel.Caption>
                  </Carousel.Item>
                ))}
              </Carousel>
            )}
            <h6 className='mt-5 mb-3 font-italic align-self-start'>
              Oleh: {`${data.firstName} ${data.lastName}`}, {' '}
              {data.artcle_tanggal}
            </h6>
            <ReactMarkdown
              source     = {data.artcle_full_story}
              escapeHtml = {false}
              className  = 'align-self-start'
            />
          </>
        )}
        <a onClick={goBack} href='/news' className='align-self-center m-3'>
          Kembali ke daftar berita
        </a>
      </Col>
    </BgRow>
  );
};

const NewsPage = ({ location, data }) => (
  <>
    <SEO title='Daftar Berita' />
    <Img fluid={data.cover.childImageSharp.fluid} />
    <Router
      basepath = {`${__PATH_PREFIX__}/news`}
      primary  = {false}
      location = {location}>
      <News path='/:slug' background={data.bg.childImageSharp.fixed.src} />
      <NewsList
        path       = '/'
        background = {data.bg.childImageSharp.fixed.src}
        location   = {location}
      />
    </Router>
  </>
);

export const query = graphql`
  {
    bg: file(name: { eq: "bg-ring" }) {
      childImageSharp {
        fixed(toFormat: WEBP) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    cover: file(name: { eq: "bg-common" }) {
      childImageSharp {
        fluid(maxWidth: 1920, toFormat: WEBP) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default NewsPage;
